import { useState } from "react";
import { useNavigate } from "react-router-dom";
const BASE_URL = process.env.REACT_APP_BASE_URL;
const IndustryForm = () => {
 const navigate=useNavigate()
  const [industryName,setIndustryName]=useState("")
  const [contactDetail,setContactDetail]=useState("")
  const [logo,setLogo]=useState("")
  const [address,setAddress]=useState("")
  const [registrationNumber,setRegistrationNumber]=useState("")
  const [govDocuments,setGovDocuments]=useState("")
  const [loading,setLoading]=useState(false)
  


  const handleSubmit = async (e) => {
    e.preventDefault();
    if(!industryName || !address || !contactDetail || !logo || !registrationNumber || !govDocuments){
      alert('all fields required')
      return;
    }
    // const data={
    //     industryName,
    //     address,
    //     contactDetail,
    //     registrationNumber,
    //     logo,
    //     govDocuments
    // }
    // console.log("The data is:",data)
    const formData = new FormData();
    formData.append("industry_name",industryName)
    formData.append("address",address)
    formData.append("contact",contactDetail)
    formData.append("registration_number",registrationNumber)
    formData.append("industry_logo",logo)
    formData.append("documents",govDocuments)
    try {
      setLoading(true)
     const response = await fetch(`${BASE_URL}/marketplace/industry/create-industry-profile/`, {
  method: 'POST',
  headers: {
    Authorization: `Bearer ${localStorage.getItem('access_token')}`,
    // "Content-Type": "multipart/form-data",
    "x-api-key": process.env.REACT_APP_X_API_KEY,
  },
  body: formData,
});

      if (response.ok) {
        console.log('Registration successful!');
        alert("University Profile Created Successfully")
      
        resetForm();
      } else {
        console.error('Registration failed');
      }
    //   alert("Registration submitted successfully!");
      navigate('/marketplace/industry')
      resetForm();
    } catch (error) {
      console.error("Error submitting form:", error);
      alert("Error submitting form. Please try again.");
    } finally{
      setLoading(false)
    }
  };

  const resetForm = () => {
    setIndustryName("")
    setContactDetail("")
    // setPointOfContact("")
    setLogo("")
    setAddress("")
    setRegistrationNumber("")
    setGovDocuments("")
  };


  return (
//     <div className="text-start max-w-4xl mx-auto mt-10 p-8 bg-gradient-to-br from-white to-gray-50 shadow-xl rounded-2xl border border-gray-100">
//       <div className="mb-8">
//         <h2 className="text-3xl font-bold text-gray-800">Industry Registration</h2>
//       </div>

//       <form onSubmit={handleSubmit} className="space-y-8">
//         {/* Basic Information Section */}
//         <div className="bg-white p-6 rounded-xl shadow-sm border border-gray-200">
          
//             {/* Name */}
// <div className="w-full mb-4">
//   <label className="block text-sm font-semibold text-gray-700 mb-2">
//     Industry Name <span className="text-red-500">*</span>
//   </label>
//     <input
//       type="text"
//       name="name"
//       value={industryName}
//       onChange={(e) => setIndustryName(e.target.value)}
//       className="mt-2 w-full border border-gray-300 rounded-xl px-4 py-3 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-200"
//       placeholder="Enter university name"
//       required
//     />

// </div>
//             {/* Contact Detail */}
//             <div className="mb-4">
//               <label className="block text-sm font-semibold text-gray-700 mb-2">
//                 Contact Detail <span className="text-red-500">*</span>
//               </label>
//               <input
//                 type="text"
//                 name="contactDetail"
//                 value={contactDetail}
//                 onChange={(e)=>setContactDetail(e.target.value)}
//                 className="w-full border border-gray-300 rounded-xl px-4 py-3 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-200"
//                 placeholder="Email or phone number"
//                 required
//               />
//             </div>
//         </div>
//         {/* Logo Upload Section */}
//         <div className="bg-white p-6 rounded-xl shadow-sm border border-gray-200">
//           <h3 className="text-xl font-semibold text-gray-800 mb-6 pb-2 border-b border-gray-200">
//             Industry Logo
//           </h3>
//           <div className="md:col-span-2">
//             {logo ? (
//               <div className="relative border border-gray-300 rounded-xl p-4">
//                 <div className="flex items-center justify-between">
//                   <div className="flex items-center space-x-4">
//                     <img 
//                       src={URL.createObjectURL(logo)} 
//                       alt="Logo preview" 
//                       className="w-16 h-16 object-cover rounded-lg"
//                     />
//                   </div>
//                 </div>
//                 <input
//                   type="file"
//                   name="logo"
//                   onChange={(e)=>setLogo(e.target.files[0])}
//                   accept="image/*"
                
//                   className="absolute inset-0 w-full h-full opacity-0 cursor-pointer"
//                 />
//               </div>
//             ) : (
//               <div className="relative border-2 border-dashed border-gray-300 rounded-2xl p-8 text-center hover:border-blue-400 transition-colors duration-200 bg-gray-50">
//                 <input
//                   type="file"
//                   name="logo"
//                   onChange={(e) => setLogo(e.target.files[0])}
//                   accept="image/*"
//                   className="absolute inset-0 w-full h-full opacity-0 cursor-pointer"
//                 />
//                 <div className="flex flex-col items-center">
//                   <svg className="w-12 h-12 text-gray-400 mb-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                     <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" />
//                   </svg>
//                   <p className="text-gray-600 font-medium">Click to upload logo</p>
//                   <p className="text-sm text-gray-500 mt-1">PNG, JPG, GIF up to 5MB</p>
//                 </div>
//               </div>
//             )}
//           </div>
//         </div>

//         {/* Address Section */}
//         <div className="bg-white p-6 rounded-xl shadow-sm border border-gray-200">
//           <h3 className="text-xl font-semibold text-gray-800 mb-6 pb-2 border-b border-gray-200">
//             Address Information
//           </h3>
          
//           <div className="md:col-span-2">
//             <label className="block text-sm font-semibold text-gray-700 mb-2">
//               Full Address <span className="text-red-500">*</span>
//             </label>
//             <textarea
//               name="address"
//               value={address}
//               onChange={(e)=>setAddress(e.target.value)}
//               className="w-full border border-gray-300 rounded-xl px-4 py-3 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-200"
//               rows={3}
//               placeholder="Enter complete university address"
//               required
//             />
//           </div>
//         </div>

//         {/* Government Documents Section */}
//         <div className="bg-white p-6 rounded-xl shadow-sm border border-gray-200">
//           <h3 className="text-xl font-semibold text-gray-800 mb-6 pb-2 border-b border-gray-200">
//             Legal Documents
//           </h3>
          
//           <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
//             {/* Registration Number */}
//             <div className="md:col-span-2">
//               <label className="block text-sm font-semibold text-gray-700 mb-2">
//                 Registration Number
//               </label>
//               <input
//                 type="text"
//                 name="registrationNumber"
//                 value={registrationNumber}
//                 onChange={(e)=>setRegistrationNumber(e.target.value)}
//                 required
//                 className="w-full border border-gray-300 rounded-xl px-4 py-3 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-200"
//                 placeholder="Official registration number"
//               />
//             </div>

//             {/* Government Documents Upload */}
//             <div className="md:col-span-2">
//               <label className="block text-sm font-semibold text-gray-700 mb-2">
//                 Government Registered Documents 
//               </label>
              
//               {govDocuments ? (
//                 <div className="relative border border-gray-300 rounded-xl p-4">
//                   <div className="flex items-center justify-between">
//                     <div className="flex items-center space-x-4">
//                       <svg className="w-12 h-12 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                         <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
//                       </svg>
//                       <div>
//                         <p className="text-sm text-gray-600">{URL.createObjectURL(govDocuments)}</p>
//                       </div>
//                     </div>
//                   </div>
//                   <input
//                     type="file"
//                     name="govDocuments"
//                     onChange={(e)=>setGovDocuments(e.target.files[0])}
//                     accept=".pdf,.doc,.docx"
//                     className="absolute inset-0 w-full h-full opacity-0 cursor-pointer"
//                   />
//                 </div>
//               ) : (
//                 <div className="relative border-2 border-dashed border-gray-300 rounded-2xl p-8 text-center hover:border-blue-400 transition-colors duration-200 bg-gray-50">
//                   <input
//                     type="file"
//                     name="govDocuments"
//                     onChange={(e)=>setGovDocuments(e.target.files[0])}
//                     accept=".pdf,.doc,.docx"
//                     className="absolute inset-0 w-full h-full opacity-0 cursor-pointer"
//                   />
//                   <div className="flex flex-col items-center">
//                     <svg className="w-12 h-12 text-gray-400 mb-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                       <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
//                     </svg>
//                     <p className="text-gray-600 font-medium">Upload government documents</p>
//                     <p className="text-sm text-gray-500 mt-1">PDF, DOC, DOCX up to 10MB</p>
//                   </div>
//                 </div>
//               )}
//             </div>
//           </div>
//         </div>
//         {/* Submit Button */}
//         <div className="pt-2">
//           <div className="flex flex-col sm:flex-row gap-4 justify-between items-center">
//             <div className="flex gap-4 w-full sm:w-auto">
//               <button
//                 type="submit"
//                 className="px-8 py-3.5 bg-gradient-to-r from-blue-600 to-indigo-600 text-white font-semibold rounded-xl hover:from-blue-700 hover:to-indigo-700 transform hover:-translate-y-0.5 transition-all duration-200 shadow-md hover:shadow-lg w-full sm:w-auto"
//               >
//                {
//                loading ? "Creating...." : "Create Industry Profile"
//                }
//               </button>
//             </div>
//           </div>
//         </div>
//       </form>
//     </div>
<div className="text-start max-w-[98%] mx-auto mt-10">
  <div className="bg-white rounded-2xl p-6 shadow-sm">
  {/* Header */}
  <div className="flex items-center gap-3 mb-8">
    <div className="w-10 h-10 bg-[#e8f0f7] rounded-lg flex items-center justify-center">
      <svg className="w-5 h-5 text-[#0f6abf]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
      </svg>
    </div>
    <div>
      <h2 className="text-2xl font-semibold text-gray-900">Industry Registration</h2>
      <p className="text-sm text-gray-500 mt-0.5">Register your industry profile</p>
    </div>
  </div>

  <form onSubmit={handleSubmit} className="space-y-6">
    {/* Basic Information */}
    <div className="bg-white rounded-2xl border border-gray-200 p-6">
      <div className="flex items-center gap-2 mb-6">
        <div className="w-1.5 h-4 bg-[#0f6abf] rounded-full"></div>
        <h3 className="text-lg font-semibold text-gray-900">Basic Information</h3>
      </div>

      <div className="grid grid-cols-1 gap-5">
        <div>
          <label className="block text-sm font-semibold text-gray-700 mb-3">
            Industry Name <span className="text-red-500">*</span>
          </label>
          <input
            type="text"
            name="name"
            value={industryName}
            onChange={(e) => setIndustryName(e.target.value)}
            className="w-full px-4 py-3 bg-gray-50 border border-gray-300 rounded-xl text-gray-900 placeholder:text-gray-400 focus:outline-none focus:border-[#0f6abf] focus:ring-2 focus:ring-[#0f6abf]/20 transition-all"
            placeholder="Enter industry name"
            required
          />
        </div>

        <div>
          <label className="block text-sm font-semibold text-gray-700 mb-3">
            Contact Detail <span className="text-red-500">*</span>
          </label>
          <input
            type="text"
            name="contactDetail"
            value={contactDetail}
            onChange={(e) => setContactDetail(e.target.value)}
            className="w-full px-4 py-3 bg-gray-50 border border-gray-300 rounded-xl text-gray-900 placeholder:text-gray-400 focus:outline-none focus:border-[#0f6abf] focus:ring-2 focus:ring-[#0f6abf]/20 transition-all"
            placeholder="Email or phone number"
            required
          />
        </div>
      </div>
    </div>

    {/* Logo Upload */}
    <div className="bg-white rounded-2xl border border-gray-200 p-6">
      <div className="flex items-center gap-2 mb-6">
        <div className="w-1.5 h-4 bg-[#0f6abf] rounded-full"></div>
        <h3 className="text-lg font-semibold text-gray-900">Industry Logo</h3>
      </div>

      <div>
        {logo ? (
          <div className="relative border-2 border-dashed border-gray-300 rounded-2xl p-6">
            <div className="flex items-center justify-center">
              <div className="relative">
                <img 
                  src={URL.createObjectURL(logo)} 
                  alt="Logo preview" 
                  className="w-20 h-20 object-cover rounded-xl"
                />
                <button
                  type="button"
                  onClick={() => setLogo(null)}
                  className="absolute -top-2 -right-2 w-6 h-6 bg-red-500 text-white rounded-full flex items-center justify-center"
                >
                  <svg className="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
                  </svg>
                </button>
              </div>
            </div>
            <input
              type="file"
              name="logo"
              onChange={(e) => setLogo(e.target.files[0])}
              accept="image/*"
              className="absolute inset-0 w-full h-full opacity-0 cursor-pointer"
            />
          </div>
        ) : (
          <div className="relative border-2 border-dashed border-gray-300 rounded-2xl p-8 text-center">
            <input
              type="file"
              name="logo"
              onChange={(e) => setLogo(e.target.files[0])}
              accept="image/*"
              className="absolute inset-0 w-full h-full opacity-0 cursor-pointer"
            />
            <div className="flex flex-col items-center">
              <div className="w-16 h-16 bg-gray-100 rounded-full flex items-center justify-center mb-4">
                <svg className="w-8 h-8 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" />
                </svg>
              </div>
              <p className="text-gray-600 font-medium mb-1">Upload Industry Logo</p>
              <p className="text-sm text-gray-500">PNG, JPG, GIF up to 5MB</p>
            </div>
          </div>
        )}
      </div>
    </div>

    {/* Address Information */}
    <div className="bg-white rounded-2xl border border-gray-200 p-6">
      <div className="flex items-center gap-2 mb-6">
        <div className="w-1.5 h-4 bg-[#0f6abf] rounded-full"></div>
        <h3 className="text-lg font-semibold text-gray-900">Address Information</h3>
      </div>

      <div>
        <label className="block text-sm font-semibold text-gray-700 mb-3">
          Full Address <span className="text-red-500">*</span>
        </label>
        <textarea
          name="address"
          value={address}
          onChange={(e) => setAddress(e.target.value)}
          className="w-full px-4 py-3 bg-gray-50 border border-gray-300 rounded-xl text-gray-900 placeholder:text-gray-400 focus:outline-none focus:border-[#0f6abf] focus:ring-2 focus:ring-[#0f6abf]/20 transition-all min-h-[100px] resize-y"
          placeholder="Enter complete industry address"
          required
        />
      </div>
    </div>

    {/* Legal Documents */}
    <div className="bg-white rounded-2xl border border-gray-200 p-6">
      <div className="flex items-center gap-2 mb-6">
        <div className="w-1.5 h-4 bg-[#0f6abf] rounded-full"></div>
        <h3 className="text-lg font-semibold text-gray-900">Legal Documents</h3>
      </div>

      <div className="space-y-5">
        <div>
          <label className="block text-sm font-semibold text-gray-700 mb-3">
            Registration Number
          </label>
          <input
            type="text"
            name="registrationNumber"
            value={registrationNumber}
            onChange={(e) => setRegistrationNumber(e.target.value)}
            required
            className="w-full px-4 py-3 bg-gray-50 border border-gray-300 rounded-xl text-gray-900 placeholder:text-gray-400 focus:outline-none focus:border-[#0f6abf] focus:ring-2 focus:ring-[#0f6abf]/20 transition-all"
            placeholder="Official registration number"
          />
        </div>

        <div>
          <label className="block text-sm font-semibold text-gray-700 mb-3">
            Government Registered Documents
          </label>
          
          {govDocuments ? (
            <div className="relative border-2 border-dashed border-gray-300 rounded-2xl p-6">
              <div className="flex  items-center justify-center">
                <div className="flex flex-col items-center gap-4">
                  <div className="w-12 h-12 bg-gray-100 rounded-lg flex items-center justify-center">
                    <svg className="w-6 h-6 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                    </svg>
                  </div>
                  <div>
                    <p className="text-sm font-medium text-gray-900">{URL.createObjectURL(govDocuments)}</p>
                    <p className="text-xs text-gray-500">Click to change</p>
                  </div>
                </div>
              </div>
              <input
                type="file"
                name="govDocuments"
                onChange={(e) => setGovDocuments(e.target.files[0])}
                accept=".pdf,.doc,.docx"
                className="absolute inset-0 w-full h-full opacity-0 cursor-pointer"
              />
            </div>
          ) : (
            <div className="relative border-2 border-dashed border-gray-300 rounded-2xl p-8 text-center">
              <input
                type="file"
                name="govDocuments"
                onChange={(e) => setGovDocuments(e.target.files[0])}
                accept=".pdf,.doc,.docx"
                className="absolute inset-0 w-full h-full opacity-0 cursor-pointer"
              />
              <div className="flex flex-col items-center">
                <div className="w-16 h-16 bg-gray-100 rounded-full flex items-center justify-center mb-4">
                  <svg className="w-8 h-8 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                  </svg>
                </div>
                <p className="text-gray-600 font-medium mb-1">Upload Government Documents</p>
                <p className="text-sm text-gray-500">PDF, DOC, DOCX up to 10MB</p>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>

    {/* Submit Button */}
    <div className="pt-6">
      <button
        type="submit"
        disabled={loading}
        className="w-full px-6 py-3.5 bg-[#0f6abf] text-white text-sm font-medium rounded-xl hover:bg-[#0a5ca8] transition-colors disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center gap-2"
      >
        {loading ? (
          <>
            <div className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin"></div>
            Creating Industry Profile...
          </>
        ) : (
          <>
            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 19l9 2-9-18-9 18 9-2zm0 0v-8" />
            </svg>
            Create Industry Profile
          </>
        )}
      </button>
    </div>
  </form>
</div>
</div>
  );
};

export default IndustryForm;